import React, { FC } from 'react';
import { useRequestWhitelabelQuery } from '@/core/services/WhiteLabeling.service';
import MarkdownParser from '@/core/components/MarkdownParser';

const DisclaimerText: FC = () => {
  const { data: whiteLabeling } = useRequestWhitelabelQuery();

  if (!whiteLabeling?.disclaimer?.enabled) {
    return null;
  }

  return (
    <MarkdownParser
      size={4}
      marginBottom={24}
      color="text-600"
      markdown={whiteLabeling.disclaimer.text}
    />
  );
};

export default DisclaimerText;
